"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
query coachTrainees {
  coachTrainees {
    id
    galleryId
    absoluteDay
    hasUnseenMeal
    hasUnreadMessage
    hasUnseenTraining
    hasUnseenRecovery
    hasUnseenBehaviour
    hasUnseenMeasurement
    hasUnseenLife
    hasUnseenMind
    
    isNew
    isProlonger
    isRejoiner
    atLeastOneNewTag
    hasChangedCoach
    newPeriodAlreadyStarted
    hasUpgraded
    hasUpgradedToCoaching
    
    firstName
    lastName
    address {
      streetName
      city
      postCode
      streetNumber
    }
    birthDate
    email
    phoneNumber
    lastActivity: lastLogin
    responseDeadline {
      iso8601
    }
    currentPeriod {
      periodId: id
      subscriptionId: periodId 
      iteration
      start
      end
      model
      day
      week
      coachingDays
      plan {
        name
      }
    
      trainingLocation {
        placeName
        details
      }
    
      code {
        label
        trainingCode
        isIndividualCode
      }
      hasIntake
    }
    periods {
      periodId: id
      subscriptionId: periodId 
      iteration
      start
      end
      model
      day
      week
      coachingDays
      plan {
        name
      }
    }
    nutritionMethod
  }
}
`;
//# sourceMappingURL=customersListQuery.js.map